<template>
  <div v-if="$store.state.app.isPortrait" class="wrap-poi-info">
    <div class="wrap-header">
      <div class="nav-back" @click="backFn">
        <i class="el-icon-arrow-left"></i>
      </div>
      路径规划
    </div>
    <div class="wrap-in">
      <!-- poi信息 -->
      <div class="poiInfo">
        <!-- 起点终点选择 -->
        <div class="location">
          <div class="location__item">
            <i class="location__icon--start"></i>
            <div class="location__item--box">
              <span class="location__item--floor"> {{ startPoint.name || '已选择的位置' }} ({{ floorMapping[startPoint.floor] }}) </span>
            </div>
          </div>

          <!-- 辅助点 -->
          <div class="location__fuzhudian">
            <i></i>
            <i></i>
            <i></i>
          </div>

          <!-- 辅助线 -->
          <div style="height:1px;width:75%;margin: 0 0 0 40px;background:#3e6c88;"></div>

          <!-- 更换 起点/终点 -->
          <div class="changeStartOrEnd" @click="changeStartOrEnd"></div>

          <div class="location__item">
            <i class="location__icon--end"></i>
            <div class="location__item--box">
              <span class="location__item--floor">{{ endPoint.name || '已选择的位置' }} ({{ floorMapping[endPoint.floor] }})</span>
            </div>
          </div>
        </div>
        <div class="close-location" @click="simulationNavHandle">开始模拟导航</div>

      </div>
      <!-- 二维码 -->
      <div class="ercode-block">
        <div class="qrcode2">
          <el-image
            class="img"
            v-if="curPoiQRcode"
            :src="curPoiQRcode"
            :preview-src-list="[curPoiQRcode]"
            @click="handleClickItem"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <div class="info">
          <div class="text1">扫码带你去</div>
          <div class="text2">{{ endPoint.name || '已选择的位置' }}</div>
        </div>
        <div class="text3">提示：使用时请开启手机蓝牙</div>
      </div>
    </div>
  </div>
  <div v-else class="wrap-route">
    <!-- 起点终点选择 -->
    <div class="location">
      <div class="location__item">
        <i class="location__icon--start"></i>
        <div class="location__item--box">
          <span class="location__item--floor"> {{ startPoint.name || '已选择的位置' }} ({{ floorMapping[startPoint.floor] }}) </span>
        </div>
      </div>

      <!-- 辅助点 -->
      <div class="location__fuzhudian">
        <i></i>
        <i></i>
        <i></i>
      </div>

      <!-- 辅助线 -->
      <div style="height:1px;width:75%;margin: 0 0 0 40px;background:#3e6c88;"></div>

      <!-- 更换 起点/终点 -->
      <div class="changeStartOrEnd" @click="changeStartOrEnd"></div>

      <div class="location__item">
        <i class="location__icon--end"></i>
        <div class="location__item--box">
          <span class="location__item--floor">{{ endPoint.name || '已选择的位置' }} ({{ floorMapping[endPoint.floor] }})</span>
        </div>
      </div>
    </div>

    <!-- 路径选择 -->
    <div v-if="transferVisible" class="transfer">
      <div v-if="transferVisible" class="transfer__item" :class="recommendPathType === ROUTE_TYPE.ELEVATOR ? 'recommend' : ''">
        <div class="transfer__btn" :class="pathType === ROUTE_TYPE.ELEVATOR ? 'active' : ''" @click="selectEscalator">
          <img v-if="pathType === ROUTE_TYPE.ELEVATOR" src="/images/preloader/lift2.png" alt="">
          <img v-else src="/images/preloader/lift1.png" alt="">
          <p>电梯</p>
        </div>
      </div>
      <div v-if="transferVisible" class="transfer__item" :class="recommendPathType === ROUTE_TYPE.ESCALATOR_DOWN || recommendPathType === ROUTE_TYPE.ESCALATOR_UP ? 'recommend' : ''">
        <div class="transfer__btn" :class="pathType === ROUTE_TYPE.ESCALATOR_DOWN || pathType === ROUTE_TYPE.ESCALATOR_UP ? 'active' : ''" @click="selectElevator">
          <img v-if="pathType === ROUTE_TYPE.ESCALATOR_DOWN || pathType === ROUTE_TYPE.ESCALATOR_UP" src="/images/preloader/escalator2.png" alt="">
          <img v-else src="/images/preloader/escalator1.png" alt="">
          <p>扶梯</p>
        </div>
      </div>
      <div v-if="transferVisible" class="transfer__item" :class="recommendPathType === ROUTE_TYPE.STAIRS ? 'recommend' : ''">
        <div class="transfer__btn" :class="pathType === ROUTE_TYPE.STAIRS ? 'active' : ''" @click="selectStairs">
          <img v-if="pathType === ROUTE_TYPE.STAIRS" src="/images/preloader/stairs2.png" alt="">
          <img v-else src="/images/preloader/stairs1.png" alt="">
          <p>楼梯</p>
        </div>
      </div>
    </div>

    <!-- 去这里 -->
    <div class="gotoHere" @click="simulationNavHandle">
      <img src="/images/preloader/icon-1.png" alt="">
      <span>开始模拟导航</span>
    </div>

    <!-- poi二维码 -->
    <div class="qrcode">
      <el-image
        class="img"
        v-if="curPoiQRcode"
        :src="curPoiQRcode"
        :preview-src-list="[curPoiQRcode]"
        @click="handleClickItem"
      >
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <div class="info">
        <div class="text1">扫码带你去</div>
        <div class="text2">{{ endPoint.name || '已选择的位置' }}</div>
        <div class="text3">提示：使用时请开启手机蓝牙</div>
      </div>
    </div>
    <!-- 后退按钮 -->
    <img class="btn-houtui" src="/images/preloader/but_huotui.png" alt="" @click="$emit('return',poiInfo,fromModule)">
    <!-- 关闭按钮 -->
    <img class="btn-close" src="/images/preloader/btn-close.png" alt="" @click="$emit('close')">
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
  },
  data () {
    return {
      dataList: [],
      dataIndex: 0, // 当前选择数据下标
      qrcodeUrl: '',
      recommendPathType: 2111, // 推荐路径类型
      routingList: [], // 路径规划列表
      poiInfo: null, // 终点poi信息
      fromModule: null
    };
  },
  computed: {
    // 建筑信息
    buildInfo: {
      get () { return this.$store.state.nav.buildInfo; },
      set (val) { this.$store.commit('nav/set_buildInfo', val); }
    },
    // 地图楼层映射
    floorMapping () {
      return this.$store.getters['nav/floorMapping'];
    },
    // 地图当前聚焦楼层
    mapFocusFloor: {
      get () { return this.$store.state.nav.mapFocusFloor; },
      set (val) { this.$store.commit('nav/set_mapFocusFloor', val); }
    },
    // 路径类型
    ROUTE_TYPE () {
      return this.$store.state.nav.ROUTE_TYPE;
    },
    NODE_TYPE_TO_ROUTE_TYPE_MAPING () {
      return this.$store.state.nav.NODE_TYPE_TO_ROUTE_TYPE_MAPING;
    },
    // 起点
    startPoint: {
      get () { return this.$store.state.nav.startPoint; },
      set (val) { this.$store.commit('nav/set_startPoint', val); }
    },
    // 终点
    endPoint: {
      get () { return this.$store.state.nav.endPoint; },
      set (val) { this.$store.commit('nav/set_endPoint', val); }
    },
    // 路径类型：0/1=自动扶梯(下/上)，2=电梯，3=楼梯
    pathType: {
      get () { return this.$store.state.nav.pathType; },
      set (val) { this.$store.commit('nav/set_pathType', val); }
    },
    // 是否显示路径类型选择
    transferVisible () {
      if ((JSON.stringify(this.startPoint) !== '{}') && (JSON.stringify(this.endPoint) !== '{}') && (this.endPoint.floor !== this.startPoint.floor)) {
        return true;
      } else {
        return false;
      }
    },
    // 请求参数
    requestParam () {
      return {
        start: this.startPoint.nodeId || this.startPoint.beaconId || this.startPoint.id,
        startFloor: this.startPoint.floor,
        end: this.endPoint.id || this.endPoint.beaconId,
        endFloor: this.endPoint.floor,
        type: this.pathType,
        buildId: this.buildInfo.buildId
      };
    },
    // 当前选中的POI二维码
    curPoiQRcode: {
      get () { return this.$store.state.nav.curPoiQRcode; },
      set (val) { this.$store.commit('nav/set_curPoiQRcode', val); }
    }
  },
  watch: {

  },
  created () {

  },
  mounted () {
    this.pathType = null;
    console.log(this.floorMapping);;
  },
  methods: {
    // 后退
    backFn () {
      this.$emit('return', this.poiInfo, this.fromModule);
    },
    // 关闭el-image遮罩层
    handleClickItem () {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask');
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click();
        });
      });
    },
    async init (poiInfo, fromModule) {
      // 记录选中的poi信息，点击返回按钮时，跳转到poi信息模块
      this.poiInfo = poiInfo;
      this.fromModule = fromModule;
      if (JSON.stringify(this.endPoint) !== '{}' && JSON.stringify(this.startPoint) !== '{}') {
        this.routing(this.requestParam);
      }
    },
    // 对换起点终点
    changeStartOrEnd () {
      this.$emit('changeStartOrEnd');
    },
    // 选择扶梯
    async selectElevator () {
      const startFloor = parseInt(this.startPoint.floor);
      const endFloor = parseInt(this.endPoint.floor);
      if (endFloor - startFloor >= 0) {
        this.pathType = this.ROUTE_TYPE.ESCALATOR_UP;
      } else {
        this.pathType = this.ROUTE_TYPE.ESCALATOR_DOWN;
      }
      return await this.routing(this.requestParam);
    },
    // 选择电梯
    async selectEscalator () {
      this.pathType = this.ROUTE_TYPE.ELEVATOR;
      return await this.routing(this.requestParam);
    },
    // 选择楼梯
    async selectStairs () {
      this.pathType = this.ROUTE_TYPE.STAIRS;
      return await this.routing(this.requestParam);
    },
    // 路径规划
    async routing (params) {
      const loading = this.$loading({
        lock: true,
        text: '路径请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        let res = await this.$apis.nav.queryShortPath(params);
        let data = JSON.parse(res.data);
        this.routingList = data || [];
        this.$emit('routing', data, this.pathType);
        loading.close();
        if (res.beaconDto && res.beaconDto.endFloor !== res.beaconDto.startFloor) {
          this.pathType = res.beaconDto.type;
        }
        return this.routingList;
      } catch (error) {
        loading.close();
        this.routingList = [];
        this.$emit('routing', [], this.pathType);
        return this.routingList;
      }
    },
    // 模拟导航
    simulationNavHandle () {
      if ((JSON.stringify(this.startPoint) === '{}')) {
        this.$message.info('请选择起点');
        return false;
      }
      if (this.startPoint.nodeId === this.endPoint.id) {
        this.$message.info('起点不能和终点相同');
        return false;
      }
      if (this.routingList.length === 0) {
        this.$message.info('没有找到该类型路径，请更换类型再试');
        return false;
      }
      console.log('simulationNav');
      this.$emit('simulationNav');
    }
  }
};
</script>

<style scoped lang="scss">
@media (orientation: landscape) {
.wrap-route {
  position: relative;
  height: 100%;
  width: 100%;
  background: url("/images/preloader/rect2.png") no-repeat;
  background-size: 100% 100%;
  padding: 45px 20px 40px 33px;
  box-sizing: border-box;
  .location {
    position: relative;
    display: flex;
    flex-direction: column;
    position: relative;
    padding-left: 15px;
    padding-right: 15px;
    background-color: #285b7a;
    border-radius: 10px;
    .changeStartOrEnd {
      position: absolute;
      top: 50%;
      right: 20px;
      height: 31px;
      width: 28px;
      transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
      background: url("/images/preloader/handover.png") no-repeat;
      background-size: 100% 100%;
    }
    .viaPointAdd {
      margin-bottom: 15px;
      position: absolute;
      top: 50%;
      right: 65px;
      height: 31px;
      width: 31px;
      transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
      // background: url("../../images/plus.png") no-repeat;
      background-size: 100% 100%;
    }
    &__item {
      display: flex;
      align-items: center;
      font-size: 18px;
      text-align: left;
      color: $color-white;
      height: 70px;
      &--floor {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      & > img {
        width: 30px;
        margin-right: 20px;
      }
      &--box {
        border-radius: 3px;
        flex: 1;
        margin-right: 100px;
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    &__icon {
      &--start,
      &--end {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin: 0 25px 0 5px;
      }
      &--start {
        background: #17da94;
      }
      &--end {
        background: #ff5952;
      }
    }
    &__fuzhudian {
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
      height: 26%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      i {
        width: 6px;
        height: 6px;
        background: #3e6c88;
        border-radius: 50%;
      }
    }
  }
  .transfer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 150px;
    background: #285b7a;
    border-radius: 10px;
    margin: 20px 0 0 0;
    overflow: hidden;
    &__item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #3e6c88;
      height: 100%;
      &:last-child{
        border:none;
      }
    }
    .recommend::before {
      content: "推荐";
      position: absolute;
      right: -10px;
      top: -20px;
      color: #fff;
      background-color: red;
      border-radius: 5px;
      padding: 1px 2px;
      font-size: 12px;
    }
    &__btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: $color-white;
      font-size: 18px;
      height: 100%;
      width: 100%;
      & > img {
      }
      & > p {
        padding: 10px 0;
        margin: 0;
      }
    }
    .active {
      background: #193a4f;
      color: #21feaf;
    }
  }
  .start-btn{
    width: 538px;
    height: 98px;
    margin: 0 auto;
  }
  .gotoHere{
    width: 100%;
    height: 70px;
    color: $color-white;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('/images/preloader/button_default_01.png') no-repeat;
    background-size: 100% 100%;
    font-size: 18px;
    box-sizing: border-box;
    margin: 40px auto 0 auto;
    span{
      margin: 0 0 0 10px;
    }
    img {
      width: 20px;
      height: 20px;
    }
  }
  .qrcode {
    height: 280px;
    padding: 15px;
    margin: 30px 0 0 0;
    box-sizing: border-box;
    display: flex;
    border: 1px solid #5480a7;
    border-radius: 20px;
    align-items: center;
    ::v-deep .el-icon-circle-close {
      color: #fff;
    }
    .img {
      width: 120px;
      border-radius: 10px;
      margin: 0 20px 0 0;
    }
    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      .text1 {
        font-size: 14px;
        color: $color-white;
      }
      .text2 {
        font-size: 20px;
        color: $color-white;
        margin: 15px 0 40px 0;
      }
      .text3 {
        font-size: 14px;
        color: #ff2828;
      }
    }
  }
  .btn-houtui{
    position: absolute;
    bottom: 40px;
    left: 50px;
    width: 120px;
  }
  .btn-close {
    position: absolute;
    bottom: 40px;
    right: 50px;
    width: 120px;
  }
}
@media screen and (max-width: 1446px) {
  .wrap-route {
  .qrcode {
      height: auto;
      padding: 15px;
      margin: 30px 0 0 0;
      box-sizing: border-box;
      display: flex;
      border: 1px solid #5480a7;
      border-radius: 20px;
      align-items: center;
      .img {
        width: 180px;
        border-radius: 5px;
        margin: 0 20px 0 0;
      }
      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
        .text1 {
          font-size: 14px;
          color: $color-white;
        }
        .text2 {
          font-size: 20px;
          color: $color-white;
          margin: 15px 0 40px 0;
        }
        .text3 {
          font-size: 14px;
          color: #ff2828;
        }
      }
    }
  }
}
}
@media (orientation: portrait) {
  .wrap-header{
    position:relative;
    height:180px;
    font-size:64px;
    color:#fff;
    font-weight:600;
  }
  .nav-back{
    position:absolute;
    left:0;
    top:0;
  }
.wrap-poi-info {
  position: relative;
  width: 100%;
  overflow: hidden;
  background:rgba(0,0,0,.2);
  // background: linear-gradient(-30deg,rgb(50,80,150) 0%, rgb(80,150,180) 100%);
  border-radius: 12px;
  background-size: 100% 100%;
  padding:58px;
  box-sizing: border-box;
  .wrap-in {
    width: 100%;
    height: calc( 100% - 140px);
    display: flex;
    text-align: left;
  }
  .poiInfo{
    position:relative;
    width: 50%;
    margin-right:4%;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 44px;
    box-sizing: border-box;
    border-radius: 28px;
    .name{
      font-size: 54px;
      color: #21feaf;
    }
    // .location{
    //   font-size: 44px;
    //   color: $color-white;
    // }
    .close-location{
      width:80%;
      text-align:center;
      display:inline-block;
      border: 1px solid rgba(255, 255, 255, 0.2);
      position:absolute;
      bottom:44px;
      left:50%;
      transform:translateX(-50%);
      font-size: 44px;
      color: $color-white;
      height:114px;
      line-height:114px;
      border-radius:60px;
      background:rgb(30,204,138)
    }
  }
  .location {
    position: relative;
    display: flex;
    flex-direction: column;
    position: relative;
    padding-left: 15px;
    padding-right: 15px;
    background-color: #285b7a;
    border-radius: 10px;
    .changeStartOrEnd {
      position: absolute;
      top: 50%;
      right: 20px;
      height: 62px;
      width: 56px;
      transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
      background: url("/images/preloader/handover.png") no-repeat;
      background-size: 100% 100%;
    }
    .viaPointAdd {
      margin-bottom: 15px;
      position: absolute;
      top: 50%;
      right: 65px;
      height: 31px;
      width: 31px;
      transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
      // background: url("../../images/plus.png") no-repeat;
      background-size: 100% 100%;
    }
    &__item {
      display: flex;
      align-items: center;
      font-size: 46px;
      text-align: left;
      color: $color-white;
      height: 140px;
      &--floor {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      & > img {
        width: 30px;
        margin-right: 20px;
      }
      &--box {
        border-radius: 3px;
        flex: 1;
        margin-right: 100px;
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    &__icon {
      &--start,
      &--end {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        margin: 0 25px 0 5px;
      }
      &--start {
        background: #17da94;
      }
      &--end {
        background: #ff5952;
      }
    }
    &__fuzhudian {
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
      height: 26%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      i {
        width: 6px;
        height: 6px;
        background: #3e6c88;
        border-radius: 50%;
      }
    }
  }
  .ercode-block{
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 44px;
    box-sizing: border-box;
    border-radius: 28px;
    position: relative;
    flex: 1;
    display: flex;
    .img{
      width: 284px;
    }
  }
  .info{
    font-size:46px;
    color: #fff;
    padding-left: 44px;
    padding-top: 44px;
    line-height: 80px;
  }
  .text3{
    position: absolute;
    color: red;
    font-size: 46px;
    bottom: 43px;
    left: 43px;
  }
  .text1 {
    font-size: 2.41vw;
  }
  .text2 {
    font-size: 2.78vw;
  }
  .text3 {
    font-size: 2.04vw;
  }
}
}
</style>
